import React from 'react'
import { FormContext, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import DOMPurify from 'dompurify'

import { DocumentContent } from '../'

const buildDefaultValues = (
  doc,
  selectedUsers,
  selectedDepartments,
  expirationConfigs,
) => ({
  allowAutomaticEditing: doc?.allowAutomaticEditing || false,
  attachment: doc?.attachment || null,
  category: doc?.category || '',
  checkOldVersions: doc?.checkOldVersions || false,
  code: doc?.code || '',
  collectAccepted: doc?.collectAccepted || false,
  collectApproval: doc?.collectApproval || false,
  content: DOMPurify.sanitize(doc?.content || ''),
  contentKind: doc?.contentKind,
  otherCategory: doc?.otherCategory || '',
  publicDocument: doc?.publicDocument || false,
  selectedDepartments: selectedDepartments || [],
  selectedUsers: selectedUsers || [],
  title: doc?.title || '',
  visibilityType: doc?.visibilityType || '',
  dueDate: expirationConfigs?.active || false,
  expirationType: expirationConfigs?.expirationType === 'signature' ? '1' : '0',
  expirationUnit: expirationConfigs?.expirationUnit || null,
  expirationTime: expirationConfigs?.expirationTime || null,
  dueDateValue: expirationConfigs?.dueDate
    ? new Date(expirationConfigs.dueDate)
    : null,
})

const DocumentShowForm = ({
  currentDocument,
  currentTab,
  documentId,
  expirationConfigs,
  isLoading,
  isWrittenContent,
  controls = {},
  pageActions = {},
  permissions = {},
  versions = {},
}) => {
  const { selectedUsers, selectedDepartments } = permissions

  const formMethods = useForm({
    defaultValues: buildDefaultValues(
      currentDocument,
      selectedUsers,
      selectedDepartments,
      expirationConfigs,
    ),
  })

  return (
    <FormContext {...formMethods}>
      <DocumentContent
        type="show"
        currentTab={currentTab}
        isLoading={isLoading}
        form={{ initialized: true }}
        documentData={{
          id: documentId,
          current: currentDocument,
          isWrittenContent,
        }}
        pageActions={pageActions}
        versions={versions}
        controls={controls}
      />
    </FormContext>
  )
}

DocumentShowForm.propTypes = {
  currentDocument: PropTypes.object,
  currentTab: PropTypes.string.isRequired,
  documentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  expirationConfigs: PropTypes.object,
  isLoading: PropTypes.bool,
  isWrittenContent: PropTypes.bool,
  controls: PropTypes.shape({
    linkedDocuments: PropTypes.array,
    isLoading: PropTypes.bool,
    pagination: PropTypes.node,
  }),
  pageActions: PropTypes.shape({
    handleBackRedirection: PropTypes.func,
    setLoading: PropTypes.func,
  }),
  permissions: PropTypes.shape({
    selectedUsers: PropTypes.array,
    selectedDepartments: PropTypes.array,
  }),
  versions: PropTypes.shape({
    documentVersions: PropTypes.array,
    isLoading: PropTypes.bool,
    downloadDocument: PropTypes.func,
    pagination: PropTypes.node,
  }),
}

export default DocumentShowForm
